if ( !customElements.get( 'grid-list' ) )
{
	class GridList extends HTMLElement {
		constructor() {
			super();

			if (FoxTheme.config.motionReduced || this.hasAttribute('motion-reduced')) return;

			this.hideGridItems();
			FoxTheme.Motion.inView(this, this.showGridItems.bind(this), { margin: '0px 0px -50px 0px' });
		}

		get gridItems() {
			return this.querySelectorAll('.f-column');
		}

		get visibleGridItems() {
			return this.querySelectorAll('.f-column:not([style])');
		}

		hideGridItems() {
			FoxTheme.Motion.animate(
				this.gridItems,
				{ transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden' },
				{ duration: 0 }
			);
		}

		showGridItems() {
			FoxTheme.Motion.animate(
				this.gridItems,
				{ transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
				{
					duration: 0.5,
					delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1),
					easing: [0, 0, 0.3, 1],
				}
			);
		}

		reShowVisibleGridItems() {
			FoxTheme.Motion.animate(
				this.visibleGridItems,
				{ transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible'] },
				{ duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1), easing: [0, 0, 0.3, 1] }
			);
		}
	}
	customElements.define('grid-list', GridList);
}